import useMediaQuery from '@mui/material/useMediaQuery';

export const isMobile = () => {
  const matches = useMediaQuery((theme) => theme.breakpoints.down('sm'), { noSsr: true });
  return matches;
};
